module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/schoolyear/school-schedule-school-year/school-schedule-school-year.component.scss
// module id = ./src/app/main/content/pages/management/schoolyear/school-schedule-school-year/school-schedule-school-year.component.scss
// module chunks = main